<template>
  <div>
    <div class="ban-p">
      <img
        v-if="result && result.headerImg"
        :src="imageUrl + result.headerImg"
      />
    </div>
    <div class="g-snva1">
      <div class="wp">
        <subnav :type="6"></subnav>
      </div>
    </div>
    <div class="row-zpb1">
      <div class="wp">
        <div class="m-formb1">
          <!-- <form> -->
          <div class="search">
            <ul>
              <li v-if="locs">
                <select
                  name="address"
                  v-model="locSelected"
                >
                  <option value="">
                    {{ $t("recruit.loc") }}
                  </option>
                  <option :value="item.id" v-for="item of locs" :key="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </li>
              <li  v-if="depts">
                <select name="department" v-model="deptSelected">
                  <option value="">
                    {{ $t("recruit.dept") }}
                  </option>
                  <option :value="item.id" v-for="item of depts" :key="item.id">
                    {{ item.departName }}
                  </option>
                </select>
              </li>
              <li>
                <input
                  name="keyword"
                  type="text"
                  :placeholder="$t('recruit.placeholder')"
                  v-model="positionTitle"
                  @keyup.enter.prevent="searchEnterFun($event)"
                  class="s"
                />
                <span class="sub" @click="serachJobs"></span>
              </li>
            </ul>
          </div>
          <!-- </form> -->
        </div>
        <div class="m-resb1">
          <ul class="ul-jobsb1" v-if="jobList.length > 0">
            <li v-for="item of jobList" :key="item.id">
              <div class="con">
                <div class="top">
                  <div class="job">
                    {{ item.positionTitle }}
                  </div>
                  <div
                    class="apply"
                    @click="showPop(item.id, item.positionTitle)"
                  >
                    {{ $t("recruit.btn") }}
                  </div>
                </div>
                <div class="tags" v-if="item.positionRequires">
                  <span
                    class="tag"
                    v-for="(tag, index) of item.positionRequires.split(
                      /[(\r\n)\r\n]+/
                    )"
                    :key="index"
                    >{{ tag }}</span
                  >
                </div>
                <div class="desc">
                  <p v-html="item.positionDesc"></p>
                </div>
                <div class="open"></div>
              </div>
            </li>
          </ul>
          <el-empty v-else :description="$t('recruit.desc')"></el-empty>
        </div>
        <div class="pages" v-if="total && total > size">
          <ul>
            <li class="prev" :class="[curPage == 1 ? 'hide' : '']">
              <span @click="prevPage">&lt;</span>
            </li>
            <li
              :class="[curPage == index + 1 ? 'on' : '']"
              v-for="(item, index) of pages"
              :key="index"
            >
              <span @click="navToPage(index + 1)">{{ index + 1 }}</span>
            </li>
            <li class="next" :class="[curPage == pages ? 'hide' : '']">
              <span @click="nextPage">&gt;</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 简历弹窗 -->
    <div class="modal-container jobs-modal" v-if="show">
      <div class="modal-bg"></div>
      <div class="modal-body">
        <div class="btn-close" @click="closePop"></div>
        <div class="body-content">
          <div class="jobs-modal-title">
            {{ $t("recruit.pop.tit") }}
          </div>
          <div class="jobs-form">
            <ul class="form-list">
              <li class="form-item flex flex-vc flex-bt">
                <label class="label-box must"
                  >{{ $t("recruit.pop.t1") }}：</label
                >
                <input
                  type="text"
                  class="input-box"
                  :placeholder="$t('recruit.pop.holder1')"
                  id="ApplicationName"
                  v-model="name"
                />
              </li>
              <li class="form-item flex flex-vc flex-bt">
                <label class="label-box must"
                  >{{ $t("recruit.pop.t2") }}：</label
                >
                <input
                  type="number"
                  class="input-box"
                  :placeholder="$t('recruit.pop.holder2')"
                  id="ApplicationPhone"
                  v-model="tel"
                />
              </li>
              <li class="form-item flex flex-vc flex-bt">
                <label class="label-box">{{ $t("recruit.pop.t5") }}：</label>
                <input
                  type="text"
                  class="input-box"
                  :placeholder="$t('recruit.pop.holder5')"
                  v-model="msg"
                  readonly
                />
              </li>
              <li class="form-item flex flex-vc flex-bt">
                <label class="label-box">{{ $t("recruit.pop.t6") }}：</label>
                <input
                  type="text"
                  class="input-box"
                  :placeholder="$t('recruit.pop.holder6')"
                  v-model="adr"
                />
              </li>
              <li class="form-item flex flex-vc flex-bt">
                <label class="label-box must"
                  >{{ $t("recruit.pop.t3") }}：</label
                >
                <input
                  type="text"
                  class="input-box"
                  :placeholder="$t('recruit.pop.holder3')"
                  id="ApplicationEmail"
                  v-model="email"
                />
              </li>
              <li class="form-item flex flex-vc flex-bt">
                <label class="label-box must"
                  >{{ $t("recruit.pop.t4") }}：</label
                >
                <div class="inputbox">
                  <!-- {{uploadPath}} -->
                  <el-upload
                    class="upload-demo"
                    :action="uploadPath"
                    :data="fileData"
                    accept=".doc,.docx,.pdf"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                  >
                    <el-button size="small" type="primary">{{
                      $t("recruit.btn1")
                    }}</el-button
                    ><span slot="tip" class="el-upload__tip">
                      {{ $t("recruit.pop.tip") }}</span
                    >
                  </el-upload>
                </div>
              </li>
            </ul>
            <div
              class="primary_btn radius_btn large_btn bottom_contact_btn"
              @click="sendMsg"
            >
              {{ $t("recruit.pop.btn") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 简历弹窗end -->
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import subnav from '@/components/subnav';
export default {
  components: {
    subnav
  },
  data () {
    return {
      loading: true,
      result: null,
      locs: [],
      depts: [],
      locSelected: '',
      deptSelected: '',
      positionTitle: '',
      url: '',
      jobList: [],
      pages: '',
      size: '',
      curPage: '',
      total: '',
      // 弹窗显示
      show: false,
      clickId: '',

      fileData: {
        bizPath: 'temp'
      },
      filename: '',
      name: '',
      tel: '',
      email: '',
      adr: '',
      dep: '',
      msg: '',
      pageInfo: {
        zhId: '1436490991380361217',
        enId: '1436491097131347969',
        jobLoc: {
          zhId: '1436620653565788162',
          enId: '1436620579284664322',
        },
        jobDept: {
          zhId: 'c6d7cb4deeac411cb3384b1b31278596',
          enId: '6d35e179cd814e3299bd588ea7daed3f',
        },
      }
    }
  },
  created () {
    let that = this;
    /* let lang = localStorage.getItem("locale") || 'zh';
    that.lang = lang;
    that.$i18n.locale = lang; */
    Loading.service();
    /* if (that.$i18n.locale === 'zh') {
      that.getJob(that.pageInfo.zhId);
      that.getJobLoc(that.pageInfo.jobLoc.zhId);
      that.getJobDept(that.pageInfo.jobDept.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.getJob(that.pageInfo.enId);
      that.getJobLoc(that.pageInfo.jobLoc.enId);
      that.getJobDept(that.pageInfo.jobDept.enId);
    } */
    that.getJob(that.pageInfo.enId);
    that.getJobLoc(that.pageInfo.jobLoc.enId);
    that.getJobDept(that.pageInfo.jobDept.enId);
    that.getJobDept();
  },
  watch: {
    '$i18n.locale' (newValue) {
      let that = this;
      Loading.service();
      that.locSelected = ''
      that.deptSelected = ''
      that.positionTitle = ''
     /*  if (that.$i18n.locale === 'zh') {
        that.getJob(that.pageInfo.zhId);
        that.getJobLoc(that.pageInfo.jobLoc.zhId);
        that.getJobDept(that.pageInfo.jobDept.zhId);
      } else if (that.$i18n.locale === 'en') {
        that.getJob(that.pageInfo.enId);
        that.getJobLoc(that.pageInfo.jobLoc.enId);
        that.getJobDept(that.pageInfo.jobDept.enId);
      } */
      that.getJob(that.pageInfo.enId);
      that.getJobLoc(that.pageInfo.jobLoc.enId);
      that.getJobDept(that.pageInfo.jobDept.enId);
    }
  },
  methods: {
    // 获取job页信息
    getJob (id) {
      let that = this;
      that.jobList = []
      let data = {
        id: id
      };
      that.$http
        .getJob(data)
        .then((res) => {
          if (res.code == 200) {
            let result = res.result;
            that.result = result;
            let dataConfigs = JSON.parse(result.dataConfigs).configs[0];
            that.url = dataConfigs.path;
            that.langKey = dataConfigs.params.langKey;
            that.page = dataConfigs.params.pageNo;
            that.serachJobs();
          }
        });
    },
    // 获取地区列表
    getJobLoc (id) {
      let that = this;

      let data = {
        "pid": id
      };
      that.$http
        .getJobLoc(data)
        .then((res) => {
          if (res.code == 200) {
            that.locs = res.result
          }
        })
        .catch((err) => { 
          that.$message(
              {
                message:err,
                type: 'error'
              }
            );
        });
    },
    // 获取职位列表
    getJobDept (id) {
      let that = this;
      let data = {
        "pid": id
      };
      that.$http
        .getJobDept(data)
        .then((res) => {
          if (res.code == 200) {
            that.depts = res.result
          }
        })
        .catch((err) => { 
          that.$message(
              {
                message:err,
                type: 'error'
              }
            );
        });
    },

    

    // 搜索职位
    serachJobs () {
      let that = this,
        url = that.url,
        langKey = that.langKey,
        locationId = that.locSelected,
        deptId = that.deptSelected,
        positionTitle = ',' + that.positionTitle + ',',
        pageNo = that.pageNo;
      Loading.service();
      that.jobList = []
      that.$axios.get(url, {
        params: {
          "langKey": langKey,
          "locationId": locationId || '',
          "deptId": deptId || '',
          "positionTitle": positionTitle || '',
          "pageNo": pageNo || 1,
          "column": 'orderNum',
          "order": 'desc'
        }
      }).then(function (res) {
        if (res.status == 200) {
          that.jobRes = res.data.result
          that.jobList = res.data.result.records
          Loading.service().close();
          that.pages = res.data.result.pages
          that.curPage = res.data.result.current
          that.total = res.data.result.total
          that.size = res.data.result.size
        }
      }).catch(function (error) {
        that.$message(
              {
                message:error,
                type: 'error'
              }
            );
      });
    },

    //点击回车，进行搜索
    searchEnterFun (e) {
      let keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.serachJobs()
      }
    },

    // 展示弹窗
    showPop (id, tit) {
      let that = this;
      that.show = true
      that.msg = tit
      if (id == that.clickId) {
        that.clickId = id
        return
      } else {
        that.filename = '';
        that.name = '';
        that.tel = '';
        that.email = '';
        that.adr = '';
        that.dep = '';
      }
    },
    closePop () {
      this.show = false
    },

    // 发送简历验证
    sendMsg () {
      let that = this;
      let obj = {};
      let tip1, tip2, tip2_1, tip3, tip3_1, tip4;
      /* if (that.lang === 'zh') {
        tip1 = '请输入您的姓名'
        tip2 = '请输入您的电话'
        tip2_1 = '电话格式错误'
        tip3 = '请输入您的邮箱'
        tip3_1 = '邮箱格式错误'
        tip4 = '请上传简历附件'
      } else if (that.lang === 'en') {
        tip1 = 'Please enter your name'
        tip2 = 'Please enter your phone number'
        tip2_1 = 'Phone format error'
        tip3 = 'Please enter your email'
        tip3_1 = 'Email format error'
        tip4 = 'Please upload your resume attachment'
      } */

      tip1 = 'Please enter your name'
      tip2 = 'Please enter your phone number'
      tip2_1 = 'Phone format error'
      tip3 = 'Please enter your email'
      tip3_1 = 'Email format error'
      tip4 = 'Please upload your resume attachment'

      obj.name = that.name
      obj.tel = that.tel
      obj.dep = that.dep || ''
      obj.msg = that.msg || ''
      obj.adr = that.adr || ''
      obj.email = that.email
      obj.filename = that.filename

      // 验证姓名
      if (obj.name == '') {
        that.$message(
          {
            message: tip1,
            type: 'warning'
          }
        );
        return false;
      }


      // 验证手机号
      if (obj.tel == '') {
        that.$message(
          {
            message: tip2,
            type: 'warning'
          }
        )
        return false;
      } /*else {
        if (!/^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(obj.tel)) {
          that.$message(
            {
              message: tip2_1,
              type: 'warning'
            }
          );
          return false;
        }
      }*/

      // 验证邮箱
      if (obj.email == '') {
        that.$message(
          {
            message: tip3,
            type: 'warning'
          }
        )
        return false;
      } else {
        let reg = /^[A-Za-z0-9-_.\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!reg.test(obj.email)) {
          that.$message(
            {
              message: tip3_1,
              type: 'warning'
            }
          );
          return false;
        }
      }

      // 验证是否上传附件
      if (obj.filename == '') {
        that.$message(
          {
            message: tip4,
            type: 'warning'
          }
        );
        return false;
      }
      that.postMsg(obj);
      Loading.service();
    },
    // 发送简历
    postMsg (obj) {
      let that = this;
      let txt;
      /* if (that.lang === 'zh') {
        txt = '发送成功！'
      } else if (that.lang === 'en') {
        txt = 'Sending succeeded!'
      } */
      txt = 'Sending succeeded!'
      let data = {
        guestName: obj.name,
        guestTel: obj.tel,
        guestMail: obj.email,
        // sysOrgCode: obj.dep,
        guestAddr: obj.adr,
        guestFile: obj.filename,
        message: obj.msg,
        type: 'recruit'
      };

      that.$http
        .postMsg(data)
        .then((res) => {
          if (res.code == 200) {
            Loading.service().close();
            that.$message(
              {
                message: txt,
                type: 'success'
              }
            );
            that.show = false
            return false;
          }
        })
    },

    // 上传附件成功
    handleSuccess (res, file) {
      this.filename = res.message
    },

    // 上传文件验证
    beforeUpload (file) {
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isLt2M = file.size / 1024 / 1024 < 5     //这里做文件大小限制
      let txt;
      let that = this;
      /* if (that.lang === 'zh') {
        txt = '文件大小不能超过5MB!'
      } else if (that.lang === 'en') {
        txt = 'The file size cannot exceed 5MB'
      } */
      txt = 'The file size cannot exceed 5MB'
      if (!isLt2M) {
        this.$message({
          message: txt,
          type: 'warning'
        });
        return false;
      }
    }
  },
}
</script>

<style>
</style>